/* KADA core helpers — shared by the size bar, In her size, Sister Match, stories, Shop the Look, Welcome back and Wishlist. Loads once. */
(function () {
  if (window.KADA) return;
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var locale = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en';
  var cache = {};

  function money(v) {
    var n = typeof v === 'number' ? v / 100 : parseFloat(v);
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: n % 1 ? 2 : 0 }).format(n);
    } catch (e) { return '$' + n.toFixed(2); }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function norm(s) { return String(s).toLowerCase().replace(/\s+/g, ''); }
  function img(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 600);
  }
  function shortTitle(t) { return String(t).split(' – ')[0].split(' | ')[0].split(' — ')[0].trim(); }

  /* Find which option is "size" (Size, Sizes, Dress size, Age, Размер) */
  function sizeIndex(p) {
    var names = (p.options || []).map(function (o) { return norm(o.name || o); });
    for (var i = 0; i < names.length; i++) {
      if (/size|размер/.test(names[i])) return i;
    }
    for (var j = 0; j < names.length; j++) { if (/age|возраст/.test(names[j])) return j; }
    return -1;
  }
  /* Turns any way of writing a size into comparable keys:
     "4T", "4 T", "4Y", "4" → y4 · "7/8 Y" → y7, y8 · "12-18 months", "12M" → m12 · "18-24" → m18 */
  function sizeKeys(raw) {
    var s = String(raw).toLowerCase().replace(/\s+/g, '').replace(/years?|yrs?/g, 'y');
    var nums = (s.match(/\d+/g) || []).map(Number);
    if (!nums.length) return [s];
    var a = nums[0], b = nums.length > 1 ? nums[1] : a;
    var months = /m/.test(s) || (/-/.test(s) && b > 16);
    if (months) return ['m' + a];
    var out = [];
    for (var n = a; n <= Math.max(a, b) && n - a < 6; n++) out.push('y' + n);
    return out;
  }
  /* [{ size: "4T", id: variantId, keys: ["y4"] }, ...] — only sizes in stock right now */
  function sizesInStock(p) {
    var i = sizeIndex(p), out = [], seen = {};
    if (i < 0) return out;
    (p.variants || []).forEach(function (v) {
      if (!v.available) return;
      var val = v['option' + (i + 1)] || (v.options && v.options[i]);
      if (!val || seen[val]) return;
      seen[val] = 1;
      out.push({ size: val, id: v.id, keys: sizeKeys(val) });
    });
    return out;
  }
  /* Finds the in-stock variant that fits a chosen size chip */
  function findSize(list, chip) {
    var want = sizeKeys(chip)[0];
    for (var j = 0; j < (list || []).length; j++) {
      if (list[j].keys.indexOf(want) > -1) return list[j];
    }
    return null;
  }

  /* Loads every product of a collection with live stock (no app needed) */
  function loadCollection(handle) {
    if (!handle) return Promise.resolve([]);
    if (cache[handle]) return cache[handle];
    var all = [];
    function page(n) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var ps = d.products || [];
          all = all.concat(ps);
          return ps.length === 250 && n < 4 ? page(n + 1) : all;
        });
    }
    cache[handle] = page(1).then(function (ps) {
      return ps.map(function (p) {
        var price = Math.min.apply(null, (p.variants || []).map(function (v) { return parseFloat(v.price); }));
        return {
          handle: p.handle, title: shortTitle(p.title), url: '/products/' + p.handle,
          price: money(price.toFixed(2)), img: p.images && p.images[0] ? p.images[0].src : '',
          img2: p.images && p.images[1] ? p.images[1].src : '',
          sizes: sizesInStock(p)
        };
      });
    }).catch(function () { return []; });
    return cache[handle];
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
      return r.json();
    }).then(function (res) {
      /* Tell the theme the cart changed (most themes listen for one of these) */
      ['cart:refresh', 'cart:updated', 'cart:change', 'theme:cart:refresh'].forEach(function (n) {
        document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: res }));
      });
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span, #CartCount')
          .forEach(function (el) { el.textContent = c.item_count; });
      }).catch(function () {});
      return res;
    });
  }

  var SIZE_KEY = 'kada-size';
  function getSize() { try { return localStorage.getItem(SIZE_KEY); } catch (e) { return null; } }
  function setSize(s) { try { localStorage.setItem(SIZE_KEY, s); } catch (e) {} }

  window.KADA = {
    money: money, esc: esc, norm: norm, img: img, shortTitle: shortTitle,
    sizeKeys: sizeKeys, sizesInStock: sizesInStock, findSize: findSize, loadCollection: loadCollection,
    addToCart: addToCart, getSize: getSize, setSize: setSize
  };
})();
